<template>
  <div class="row">
    <div class="col-12">
      <section-title
        container-class="tag-badge-main-info mt-4 mb-4"
        content="V. Resultados de Evaluaciones"
        icon="fas fa-clipboard-list-check"
      />

      <div v-for="item in model.instruments" :key="item.id">
        <result-row :is-read-only="isReadOnly" :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
//mixins

//utils
import { copy } from '@/utils/objUtils';

//filters

//components
import SectionTitle from '@/shared/components/SectionTitle.vue';

import ResultRow from './components/ResultRow.vue';

//services
import { getFive } from '@/modules/vocational-evaluation/api.js';

export default {
  name: 'VocationalEducationPartFive',
  components: {
    SectionTitle,
    ResultRow,
  },
  mixins: [],
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    appointmentId: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    initialModel: {
      type: Object,
      required: false,
      default: () => null,
    },
    keepUpdates: {
      type: Boolean,
      required: false,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    filled() {
      return this.initialModel?.filled ?? false;
    },
  },
  async mounted() {
    this.$emit('update:disabled', true);
    await this.get();
    this.$emit('update:disabled', false);
  },
  beforeDestroy() {
    this.$emit('update:initialModel', this.model);
  },
  methods: {
    setModelFrom(value) {
      const data = copy(value);
      this.model = data;
      this.$emit('update:initialModel', data);
    },
    async get() {
      if (this.keepUpdates && this.filled) {
        this.setModelFrom(this.initialModel);
        return;
      }
      const { data } = await getFive({
        id: this.id,
        appointmentId: this.appointmentId,
      });
      const result = { ...data, filled: true };

      this.results = result.instruments.map((x) => ({ ...x, opened: false }));
      this.setModelFrom(result);
    },
    async validate() {
      return true;
    },
    open(item) {
      item.opened = !item.opened;
    },
  },
};
</script>
<style scoped></style>
